// extracted by mini-css-extract-plugin
module.exports = {"container":"Snackbar_container__pWtS9","warning":"Snackbar_warning__2pBZt","error":"Snackbar_error__2jOS_","success":"Snackbar_success__T6aMA","icon":"Snackbar_icon__1KvsG"};